import React from 'react'
import PropTypes from 'prop-types'

const TimeWithPageIcon = (props) => {
  const { fillColor, height, width } = props

  return (
    <svg width={width} height={height} viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0)">
        <path
          d="M27.5359 5.1828H10.6297C10.2737 5.1828 9.98517 5.47129 9.98517 5.82733C9.98517 6.18337 10.2737 6.47186 10.6297 6.47186H27.5359C27.892 6.47186 28.1805 6.18337 28.1805 5.82733C28.1805 5.47129 27.892 5.1828 27.5359 5.1828Z"
          fill={fillColor}
        />
        <path
          d="M27.5359 11.6099H10.6297C10.2737 11.6099 9.98517 11.8984 9.98517 12.2545C9.98517 12.6105 10.2737 12.899 10.6297 12.899H27.5359C27.892 12.899 28.1805 12.6105 28.1805 12.2545C28.1805 11.8984 27.892 11.6099 27.5359 11.6099Z"
          fill={fillColor}
        />
        <path
          d="M27.5359 18.0371H10.6297C10.2737 18.0371 9.98517 18.3256 9.98517 18.6816C9.98517 19.0377 10.2737 19.3262 10.6297 19.3262H27.5359C27.892 19.3262 28.1805 19.0377 28.1805 18.6816C28.1805 18.3256 27.892 18.0371 27.5359 18.0371Z"
          fill={fillColor}
        />
        <path
          d="M31.9199 22.7382C26.8612 22.7382 22.7457 26.8537 22.7457 31.9124C22.7457 36.9711 26.8611 41.0868 31.9199 41.0868C36.9787 41.0868 41.0942 36.9711 41.0942 31.9124C41.0942 26.8537 36.9786 22.7382 31.9199 22.7382V22.7382ZM31.9199 39.7977C27.572 39.7977 24.0347 36.2604 24.0347 31.9124C24.0347 27.5645 27.572 24.0272 31.9199 24.0272C36.2678 24.0272 39.8051 27.5645 39.8051 31.9124C39.8051 36.2604 36.2678 39.7977 31.9199 39.7977Z"
          fill={fillColor}
        />
        <path
          d="M31.9199 26.6523C32.276 26.6523 32.5645 26.3638 32.5645 26.0078V25.7125C32.5645 25.3565 32.276 25.068 31.9199 25.068C31.5639 25.068 31.2754 25.3565 31.2754 25.7125V26.0078C31.2754 26.3638 31.5639 26.6523 31.9199 26.6523Z"
          fill={fillColor}
        />
        <path
          d="M35.8483 27.0727L35.6395 27.2814C35.3877 27.5331 35.3876 27.9413 35.6392 28.1929C35.8907 28.4445 36.2988 28.4449 36.5507 28.1931L36.7595 27.9844C37.0113 27.7327 37.0114 27.3246 36.7598 27.0729C36.508 26.8211 36.0999 26.8211 35.8483 27.0727Z"
          fill={fillColor}
        />
        <path
          d="M37.18 31.9124C37.18 32.2685 37.4685 32.5569 37.8245 32.5569H38.1198C38.4758 32.5569 38.7643 32.2685 38.7643 31.9124C38.7643 31.5564 38.4758 31.2679 38.1198 31.2679H37.8245C37.4685 31.2679 37.18 31.5565 37.18 31.9124Z"
          fill={fillColor}
        />
        <path
          d="M26.0153 31.2679H25.72C25.3639 31.2679 25.0754 31.5564 25.0754 31.9124C25.0754 32.2685 25.3639 32.5569 25.72 32.5569H26.0153C26.3713 32.5569 26.6598 32.2685 26.6598 31.9124C26.6598 31.5564 26.3712 31.2679 26.0153 31.2679Z"
          fill={fillColor}
        />
        <path
          d="M36.5507 35.6318C36.2989 35.38 35.8908 35.3801 35.6392 35.6321C35.3876 35.8838 35.3877 36.2919 35.6395 36.5436L35.8483 36.7523C36.0998 37.0038 36.508 37.004 36.7598 36.752C37.0114 36.5003 37.0113 36.0922 36.7595 35.8406L36.5507 35.6318Z"
          fill={fillColor}
        />
        <path
          d="M31.9199 37.1725C31.5639 37.1725 31.2754 37.461 31.2754 37.8171V38.1124C31.2754 38.4684 31.5639 38.7569 31.9199 38.7569C32.276 38.7569 32.5645 38.4684 32.5645 38.1124V37.8171C32.5645 37.4611 32.2759 37.1725 31.9199 37.1725Z"
          fill={fillColor}
        />
        <path
          d="M27.2889 35.6318L27.0801 35.8406C26.8284 36.0924 26.8284 36.5004 27.0801 36.7521C27.332 37.0038 27.74 37.0037 27.9917 36.7521L28.2004 36.5434C28.4521 36.2916 28.4521 35.8835 28.2004 35.6318C27.9487 35.3803 27.5407 35.3803 27.2889 35.6318Z"
          fill={fillColor}
        />
        <path
          d="M27.9917 27.0728C27.7399 26.8211 27.3319 26.8211 27.0802 27.0728C26.8285 27.3246 26.8285 27.7326 27.0802 27.9843L27.2889 28.193C27.5408 28.4448 27.9488 28.4447 28.2005 28.193C28.4522 27.9412 28.4522 27.5332 28.2005 27.2815L27.9917 27.0728Z"
          fill={fillColor}
        />
        <path
          d="M33.6767 31.2678H32.5645V28.5106C32.5645 28.1546 32.276 27.8661 31.9199 27.8661C31.5639 27.8661 31.2754 28.1546 31.2754 28.5106V31.9124C31.2754 32.2684 31.5639 32.5569 31.9199 32.5569H33.6767C34.0327 32.5569 34.3212 32.2684 34.3212 31.9124C34.3212 31.5563 34.0327 31.2678 33.6767 31.2678Z"
          fill={fillColor}
        />
        <path
          d="M41.7245 24.8555C41.5161 24.5668 41.1134 24.5017 40.8246 24.7097C40.5359 24.9179 40.4706 25.3207 40.6788 25.6096C42.0082 27.4534 42.7109 29.633 42.7109 31.9127C42.7109 37.863 37.8701 42.7038 31.9199 42.7038C25.9697 42.7038 21.1289 37.863 21.1289 31.9127C21.1289 25.9626 25.9697 21.1217 31.9199 21.1217C34.5436 21.1217 37.0729 22.0752 39.0418 23.8064C39.309 24.0412 39.7164 24.0153 39.9515 23.7479C40.1864 23.4806 40.1604 23.0733 39.893 22.8383C37.7736 20.9747 35.0743 19.9167 32.2589 19.8379V9.76449H37.7626C38.4491 9.76449 39.0077 9.2059 39.0077 8.51935V4.02679C39.0077 1.76225 37.1319 0.00775146 35.055 0.00775146H19.9068C19.5508 0.00775146 19.2623 0.296244 19.2623 0.652283C19.2623 1.00832 19.5508 1.29681 19.9068 1.29681H32.0428C31.3776 2.01422 30.9698 2.97354 30.9698 4.02679V19.8699C27.5046 20.1408 24.4453 21.88 22.4154 24.4645H10.6297C10.2737 24.4645 9.98516 24.753 9.98516 25.1091C9.98516 25.4651 10.2737 25.7536 10.6297 25.7536H21.5318C20.8007 26.9819 20.2809 28.3497 20.0237 29.8073H6.68456V3.33577C6.68456 2.21153 7.59928 1.29681 8.72352 1.29681H17.3298C17.6859 1.29681 17.9743 1.00832 17.9743 0.652283C17.9743 0.296244 17.6859 0.00775146 17.3298 0.00775146H8.72352C6.88841 0.00775146 5.3955 1.50066 5.3955 3.33577V29.8073H0.644531C0.288492 29.8073 0 30.0958 0 30.4518V31.7011C0 34.6871 2.42945 37.1165 5.41552 37.1165H7.49126C7.8473 37.1165 8.13579 36.828 8.13579 36.472C8.13579 36.1159 7.8473 35.8274 7.49126 35.8274H5.41552C3.14016 35.8274 1.28906 33.9764 1.28906 31.7011V31.0963H19.8679C19.8498 31.3663 19.8397 31.6383 19.8397 31.9127C19.8397 33.2823 20.0692 34.5991 20.4911 35.8274H10.0683C9.71223 35.8274 9.42373 36.1159 9.42373 36.472C9.42373 36.828 9.71223 37.1165 10.0683 37.1165H21.0193C22.967 41.18 27.121 43.993 31.9199 43.993C38.5809 43.993 43.9999 38.5738 43.9999 31.9128C44 29.3607 43.2132 26.9203 41.7245 24.8555V24.8555ZM37.7187 4.02679V8.47543H32.2589V4.02679C32.2589 2.52142 33.4835 1.29681 34.9889 1.29681C36.494 1.29681 37.7187 2.52142 37.7187 4.02679V4.02679Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="44" height="44" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

TimeWithPageIcon.propTypes = {
  fillColor: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
}

TimeWithPageIcon.defaultProps = {
  fillColor: '#000000',
  height: 40,
  width: 40,
}

export default TimeWithPageIcon
